import PostSensorLogRequestModelBase from '../_generated/modelBases/post-sensor-log-request-model-base';

export default class PostSensorLogRequestModel extends PostSensorLogRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
